/**
 *
 * @param {array} options - Array of options for Dropdown element
 *
 * Simple option
 * {
 *      key: {string},
 *      value: {string|number},
 *      text: {string|JSX},
 * }
 *
 * Header of grouped options
 * has text which is the group name
 * and array grouped items
 * {
 *      key: {string},
 *      text: {string|JSX},
 *      items: {array of [Simple options]},
 * }
 */

import React from 'react';

import {
    Dropdown,
    DropdownExtendedProps,
} from 'reactComponents/Dropdown/Dropdown';

import { BasicField, BasicFieldProps } from './_BasicField';

export type FieldSelectProps = DropdownExtendedProps &
    Omit<BasicFieldProps, 'control'>;
export function FieldSelect({
    onChange,
    name,
    Component,
    dataTest = 'select',
    ...otherSelectProps
}: FieldSelectProps) {
    return (
        <BasicField
            {...otherSelectProps}
            dataTest={dataTest}
            name={name}
            control={Component || Dropdown}
            onChange={(...args) => {
                return (
                    onChange &&
                    Promise.resolve().then(() => {
                        (onChange as any)(...args); // TODO: make it sync!
                    })
                );
            }}
        />
    );
}

// todo: check что все ок
FieldSelect.enumToSelectOptions = function<T>(enumParam: T) {
    return FieldSelect.mapOptions(Object.values(enumParam));
};

FieldSelect.mapOptions = function<T>(arr: T[], key?: string) {
    return arr.map((item) => {
        const val = key ? item[key] : item;
        return {
            key: val,
            value: val,
            text: val,
        };
    });
};
